
import { Vue, Component } from "vue-property-decorator";
import { regionData } from "element-china-area-data";
import areaArr from "@/components/world.js";
@Component({
  name: "withdrawalHandle",
})	
export default class withdrawalHandle extends Vue {
	
  data() {
    return {
		realName:'',
		account:'',
		money:'',
		remarks:'',
		selectPaymethod: [{
		  value: '选项1',
		  label: '支付宝'
		}, {
		  value: '选项2',
		  label: '微信'
		}],
		selectMethod: '',
		
		data:{
			name: "",
			phone: "",
			profile: "",
			sex: "",
			addr: "",
			type: "",
			password: "",
			enable: "",
			email: "",
			updateTime:"",
		},
		url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
		value: [[17,18,19],[1,7,10],[1,2,3]],
		options : regionData,
		selectedOptions:[],
		areaArr:areaArr,
		radio: '2'
	}
  };
  private onCancel(){
	  
	  console.log('取消')
	  this.$router.back();
  }
  private onSubmit() {
    console.log(this.data);
	// let addr = this.data.addr;
	// let email = this.data.addr;
	// let name = this.data.addr;
	// let profile = this.data.addr;
	// let sex = this.data.addr;
	// let updateTime = this.data.addr;
	// let paramter = {
		
	// 	addr,
	// 	email,
	// 	name,
	// 	profile,
	// 	sex,
	// 	updateTime
	// };
	// let paramters = {
	// 	'addr':this.data.addr,
	// 	'email':'930045390@qq.com',
	// 	'name':this.data.name,
	// 	'profile':this.data.profile,
	// 	'sex':this.data.sex,
	// 	'updateTime':'2020-11-10 19:23:32'
	// };

	// let id = this.$route.query.id;
	// console.log('data',paramter);
	// this.$http.put('user/edit/'+id,{params:paramters}).then((res: any) =>{
		
	// 	let datas = res.data.data.data;
	// 	console.log('更新成功',res);
		
	// });
  };
  private handleChange(value){
	  
	  console.log('ddd',value);
  };
  private mounted(){
	  
	let tempData:any = {};
	let id = this.$route.query.id;
	this.$http.get("user/"+id, {}).then((res: any) => {
		tempData = res.data.data;
		this.data = tempData;
		// this.data = {
		// 	name:tempData.name,
		// 	phone:tempData.phone,
		// 	profile:tempData.profile,
		// 	sex:tempData.sex==0?'2':'1',
		// 	addr:tempData.addr,
		// 	type:tempData.type,
		// 	password:tempData.password,
		// 	enable:tempData.enable==1?true:false,
		// 	updateTime:tempData.updateTime,
		// 	email:tempData.email
		// };
		console.log('radio',tempData);
	});
  }
}
	
